<template>
  <div class="pb-4 px-2 text-gray">
    <div class="pb-4 text-xs text-black">Beans</div>
    <div class="border-l-4 border-gray-lighter">
      <div v-for="(t, i) in txs"
        class="flex justify-between p-4 items-center border-b border-gray-lighter">
        <div class="font-bold font-mono" v-html="parsedSymbol(t.symbol)" />
        <div
          class="font-bold font-mono"
          :class="{
            'text-light-red': t.amount < 0,
            'text-dark-green': t.amount > 0
          }">{{t.amount}}</div>
      </div>
    </div>
  </div>
</template>

<script>
 export default {
   props: {
     txs: {
       type: Array,
       required: true
     }
   },
   methods: {
     parsedSymbol (sym) {
       return twemoji.parse(sym)
     }
   }
 }
</script>
